export default {"src":"/_next/static/media/wriggly-arrow-up.5f3cbd76.svg","height":160,"width":223,"blurWidth":0,"blurHeight":0};